// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2178":"7dceab7a","3152":"7dceab7a","4082":"7dceab7a","7377":"8bd45e09","8203":"7dceab7a"}[chunkId] + ".chunk.css";
};